module.exports = __webpack_public_path__ + "static/media/desconectado.72afa340.svg";